var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"supplier-contact-changed-invitation-handler"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"layout-column flex-center"},[_c('rbv-loading',{attrs:{"label":"Loading, please wait..."}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }